import React from "react";
const IconMenu = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width="20" height="20" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" {...props}>
    <path d="M17 15v2H0v-2h17Zm-5-6v2H0V9h12Zm8-6v2H0V3h20Z" fill="currentColor" />
  </svg>
);
export default IconMenu;
